export enum responseMsg {
  NotEnoughBalance = 'not_enough_balance',
}